
<template>
  <div class="nutrient_selection_tab_class">
    <div class="left_select_class">
      <span>营养指标类型</span>
      <a-input-search placeholder="请输入" size="large" @search="onSearch">
        <a-button slot="enterButton">
          搜索
        </a-button>
      </a-input-search>
      <a-radio-group v-model="value" @change="onChange">
        <div v-for="el in searchList" :key="el.name" class="radioBox">
          <a-radio :value="el.name">
            {{el.name}}
          </a-radio>
        </div>
      </a-radio-group>
    </div>
    <div class="right_table_class">
      <span>营养指标</span>
      <a-table :columns="columns" :data-source="list" class="tableBox" rowKey='name'>
        <template v-for="el in row">
          <a-checkbox :slot="el.feild" slot-scope="text,record" :key="el.name" :value="record.feild" />
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      list: [
        {name: '肉鸡1',code: 'C12',xxx1: false,xxx2: false,xxx3: false,xxx4: false},
        {name: '肉鸡2',code: 'C12',xxx1: false,xxx2: false,xxx3: false,xxx4: false},
        {name: '肉鸡3',code: 'C12',xxx1: false,xxx2: false,xxx3: false,xxx4: false},
        {name: '肉鸡4',code: 'C12',xxx1: false,xxx2: false,xxx3: false,xxx4: false}
      ],
      fixedColumn: [
        {title: '名称',dataIndex: 'name'},
        {title: '代码',dataIndex: 'code'}
      ],
      columns: [],
      row: [
        {name: 'Na',feild: 'xxx1'},
        {name: 'DM',feild: 'xxx2'},
        {name: 'Ash',feild: 'xxx3'},
        {name: 'CP',feild: 'xxx4'}
      ],
      searchList: [{name: 1}],
      value:''
    }
  },
  created(){
    this.getData();
  },
  methods:{
    getData(){
      this.columns = this.fixedColumn;
      this.row.forEach(item => {
        this.columns.push({
          title: item.name,
          dataIndex: item.feild,
          scopedSlots: { customRender: item.feild }
        })
      })
    },
    onSearch(){
      this.list = [
        {name:'name1'},
        {name:'name2'},
        {name:'name3'},
        {name:'name4'},
        {name:'name5'},
        {name:'name6'}
      ]
    },
    onChange(e) {
      console.log('radio checked', e.target.value);
    }
  }
}
</script>

<style lang="scss" scoped>
.nutrient_selection_tab_class {
  display: flex;
  .left_select_class {
    flex: 1;
  }
  .right_table_class {
    flex: 2;
  }
  .tableBox{
    padding: 0;
    height: 100%;
  }

}
</style>